<template lang="html">
    <div class="page-container">
        <div class="page-container__header">
            <h1 class="header-1 page-container__title">Setări</h1>
        </div>
        <div class="page-container__body">
            <CardPassword />
            <CardProfile />
            <CardImageAndVideo />
            <CardTitleAndBasePrice />
            <CardDescription />
            <CardTimetable ref="timetable" />
        </div>
    </div>
</template>

<script>
import UiInput from "@/components/ui/Input"
import UiButton from "@/components/ui/Button"
import CardPassword from '@/pages/client/SettingsPage/components/CardPassword'
import CardProfile from '@/pages/client/SettingsPage/components/CardProfile'
import CardImageAndVideo from '@/pages/specialist/SettingsPage/components/CardImageAndVideo'
import CardTitleAndBasePrice from '@/pages/specialist/SettingsPage/components/CardTitleAndBasePrice'
import CardDescription from '@/pages/specialist/SettingsPage/components/CardDescription'
import CardTimetable from '@/pages/specialist/SettingsPage/components/CardTimetable'
import { mapGetters } from 'vuex'
export default {
    components: {
        UiInput,
        UiButton,
        CardPassword,
        CardProfile,
        CardImageAndVideo,
        CardTitleAndBasePrice,
        CardDescription,
        CardTimetable
    },
    mounted() {
        this.scrollToTimetable();
    },
    computed: {
        ...mapGetters({
            user: 'user/user'
        }),
    },
    methods: {
        scrollToTimetable() {
            if (
                this.$route.hash === '#disponibilitate' ||
                this.$route.query.bottom === null
            ) {
                this.$refs.timetable.$el.scrollIntoView();
                this.$router.push({ hash: 'disponibilitate' });
            }
        }
    },
    watch: {
        '$route.query.bottom'() {
            this.scrollToTimetable();
        }
    }
}
</script>

<style lang="scss">
    @import "@/scss/pages/client-settings";
    .error {
        color: $color-danger;
        text-align: center;
    }
</style>